import React from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

 
class Footer extends React.Component {
    render(){
        return (
            <footer className="footer-area" style={{marginTop: "5px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="single-footer-widget">
                                <h3>Nexus Events and Media
                                </h3>
                                {/* <span>
                                    <i className="icofont-calendar"></i> 21-24 March, 2024
                                </span> */}

                                <p className="location">
                                    {/* <i className="icofont-google-map"></i> Treasure Island Resort,Lonavala, Pune */}
                                </p>

                                <a href='tel:+918108818113' className="contact-authority">
                                    <i className="icofont-phone"></i>+91-81088-18113

                                </a>
                                <div className="contact-authority">
                                    <i className="icofont-location-pin"></i> Pune<br />
                                </div> <div className="contact-authority">
                                    <i className="icofont-location-pin"></i> Mumbai
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6 col-md-6">
                            <div className="single-footer-widget">
                                {/* <h3>Social Connection</h3> */}
                                <h3>Socials</h3>
                                
                               <ul className="social-links">
                                    <li>
                                        <a href="https://www.facebook.com/nexuseventsandmedia/" className="facebook" target="_blank">
                                            <i className="icofont-facebook"></i>
                                        </a>
                                    </li>
                                   
                                    <li>
                                        <Link to="https://www.linkedin.com/" className="linkedin" target="_blank">
                                            <i className="icofont-linkedin"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/nexusevents__/" className="instagram" target="_blank">
                                            <i className="icofont-instagram"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a   className="twitter" target="_blank">
                                            <i className="icofont-twitter"></i>
                                        </a>
                                    </li>
                                </ul> 
                            </div>
                        </div>

                        <div className="col-lg-12">
                            <div className="copyright-area">
                                <div className="logo"  >
                                    <HashLink smooth to="#banner">
                                        <img src={require("../../assets/images/nexus logo main.png")} alt="logo" style={{height:"55px", marginBottom: "20px"}}/>
                                    </HashLink>
                                </div>
                                {/* <ul>
                                    <li><HashLink smooth to="/#about">About</HashLink></li>
                                    <li><HashLink smooth to="/#venue">Venue</HashLink></li>
                                    <li><HashLink smooth  to="/#speakers">Speakers</HashLink></li>
                                    <li><HashLink smooth  to="/#agenda">Agenda</HashLink></li>
                                    <li><HashLink smooth  to="/#sponsors">Sponsor</HashLink></li>
                                    <li><HashLink smooth  to="/#register">Register</HashLink></li>

                                </ul> */}
                                <p>
                                 {/* <i className="icofont-copyright"></i> */}

                                 Made with ❤ by <a href='https://variantspark.com' target='_blank'> Variant Spark</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}
 
export default Footer;